import React from "react";
import { NavLink } from "react-router-dom";
import { ThemePalette } from "../../../../theme/_Types";
import * as I18n from "../../../../utils/translations/I18n";
import { Div } from "../../03-base/Div";
import { Button } from "../../05-atoms/Button";
import { IconNames } from "../../05-atoms/Icon";
import { Heading, Headings } from "../../05-atoms/Heading";
import { RTE } from "../../07-organisms/RTE";
export var Header = function (props) { return (React.createElement(Div, { theme: {
        padding: {
            "": { b: 3 },
            "sm": { b: 3 },
        },
    } },
    React.createElement(Div, { style: { display: "flex", flexDirection: "row" } },
        props.goBack &&
            React.createElement(Div, { style: { flex: 1, flexGrow: 0 }, theme: {
                    padding: {
                        "": { r: 2 },
                        "sm": { r: 3 },
                    },
                } },
                React.createElement(NavLink, { to: props.goBack, exact: true },
                    React.createElement(Button, { icon: IconNames.ARROW_LEFT, theme: { palette: ThemePalette.BRAND_ACCENT } }))),
        React.createElement(Div, { style: { flex: 1, alignSelf: "center" } },
            props.goBack ?
                React.createElement(Heading, { level: Headings.H1, headingStyle: Headings.H4 }, I18n.getText(props.title))
                :
                    React.createElement(Heading, { level: Headings.H1, headingStyle: Headings.H3 }, I18n.getText(props.title)),
            props.description &&
                React.createElement(Div, { theme: {
                        padding: {
                            "": { t: 1 },
                            "sm": { t: 1 },
                        },
                    } },
                    React.createElement(RTE, null, I18n.getText(props.description))))))); };
